{
  "email-phone-confirmation-pin-dialog": {
    "buttons": {
      "resend": "Znovu odeslat",
      "submit": "Odeslat"
    },
    "text": {
      "email-confirmation": "Potvrzení e-mailem",
      "enter-to-confirm-email": "Zadejte prosím PIN kód pro potvrzení e-mailu",
      "enter-to-confirm-phone": "Zadejte prosím kód PIN pro potvrzení telefonního čísla",
      "in-second": "v {{seconds}} s",
      "phone-confirmation": "Potvrzení telefonního čísla",
      "pin-sent-to-email": "Kód PIN je zaslán na váš e-mail",
      "pin-sent-to-phone": "Kód PIN je zaslán na vaše telefonní číslo",
      "update-success": "Úspěšně aktualizováno!"
    }
  }
}
